import React, { createContext, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { useContentFromDB, UseContentFromDBResult } from '../hooks/useContentFromDB';

const ContentContext = createContext<UseContentFromDBResult | null>(null);

export function useSharedContent(): UseContentFromDBResult {
  const ctx = useContext(ContentContext);
  if (!ctx) {
    throw new Error('useSharedContent must be used within ContentProvider');
  }
  return ctx;
}

export const ContentProvider: React.FC = () => {
  const contentResult = useContentFromDB();

  return (
    <ContentContext.Provider value={contentResult}>
      <Outlet />
    </ContentContext.Provider>
  );
};
